





















declare global {
  interface Window {
    $: boolean;
  }
}

import { Vue, Component } from 'vue-property-decorator';
import AcgnSVGTag from '@acgn/svg';
import localStorage from '@acgn/svg/src/js/localStorage';
import operateFlags from '@acgn/svg/src/js/shared/operateFlags';
import jQuery from 'jquery';
import { getpostil, addpostil } from '@/api/sign';
const domain = (window as any).configs.imageDomain;
// 全局挂载jquery
window.$ = jQuery;

@Component
export default class Sign extends Vue {
  private images: any = []; // 标记图片地址
  private storageData: any = []; // 存储数据
  private storageKey: string = '_acgnsvg__';
  private async created() {
    const { instance_id } = this.$route.query;
    this.storageKey = instance_id;

    // 获取需要标记的图片
    getpostil({ instance_id }).then(({ result }: any) => {
      const images = JSON.parse(result.preview_images);
      this.images = images.map((item: string) => domain  + item);

      // 初始数据
      const postil = JSON.parse(result.record.postil_json || null);
      if (!!postil) {
        localStorage.setItem(this.storageKey, postil);
      }
      const storageData = localStorage.getItem(this.storageKey, null);
      this.storageData = postil || storageData || [];
      return new AcgnSVGTag({
        containerId: 'markBoxMain',
        data: this.storageData,
        status: result.status === 0, // 是否可以标记
        callback: (current: any, list: any, type: number) => {

          // 数据改变回调 data：当前节点数据，list：总数据
          localStorage.setItem(this.storageKey, list);
          if (type & operateFlags.INPUT) {
            addpostil({
              instance_id: this.storageKey,
              postil_json: JSON.stringify(list),
            });
            // this.throttle(
            //   addpostil,
            //   [
            //     {
            //       instance_id: this.storageKey,
            //       postil_json: JSON.stringify(list),
            //     },
            //   ],
            //   300,
            //   this
            // );
          }
        },
      });
    });
  }

  private throttle(method: any, params: any, hold = 50, context: any) {
    clearTimeout(method.timer);
    method.timer = setTimeout(() => {
      method.apply(context, params);
    }, hold);
  }
}
